import { render, staticRenderFns } from "./BasePushRedirection.vue?vue&type=template&id=382a632d&scoped=true&"
import script from "./BasePushRedirection.vue?vue&type=script&lang=js&"
export * from "./BasePushRedirection.vue?vue&type=script&lang=js&"
import style0 from "./BasePushRedirection.vue?vue&type=style&index=0&id=382a632d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382a632d",
  null
  
)

export default component.exports